import { render, staticRenderFns } from "./LookforPassword.vue?vue&type=template&id=6173bd90&scoped=true&"
import script from "./LookforPassword.vue?vue&type=script&lang=js&"
export * from "./LookforPassword.vue?vue&type=script&lang=js&"
import style0 from "./LookforPassword.vue?vue&type=style&index=0&id=6173bd90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173bd90",
  null
  
)

export default component.exports